import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ToastService } from './toast.service';

/**
 * `<nb-toast-host>` — renders the `ToastService` toast (2026-09 prototype: an
 * inverted --text pill at the bottom centre, slides up with `nb-toast`).
 *
 * Place it ONCE per app, as a late sibling of the routed content so it stacks
 * above the tab bar. The live region is always present (empty when idle) so
 * screen readers announce the message when it appears; `bottom` positions it
 * above sticky chrome (default clears the tab bar + safe area).
 *
 * @example <nb-toast-host bottom="calc(var(--safe-bottom) + 84px)" />
 */
@Component({
  selector: 'nb-toast-host',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[style.--nb-toast-bottom]': 'bottom()' },
  template: `<div class="live" role="status" aria-live="polite" aria-atomic="true">
    @if (toasts.current(); as t) {
      <div class="toast">{{ t.message }}</div>
    }
  </div>`,
  styleUrl: './toast.css',
})
export class NbToastHost {
  protected readonly toasts = inject(ToastService);
  /** CSS length for the toast's distance from the viewport bottom. */
  readonly bottom = input('calc(var(--safe-bottom) + 84px)');
}
